import { render, staticRenderFns } from "./ScoreHistory.vue?vue&type=template&id=7af1e9c8&scoped=true&"
import script from "./ScoreHistory.vue?vue&type=script&lang=js&"
export * from "./ScoreHistory.vue?vue&type=script&lang=js&"
import style0 from "./ScoreHistory.vue?vue&type=style&index=0&id=7af1e9c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af1e9c8",
  null
  
)

export default component.exports